import React from "react";
import { StyleProp, ViewStyle } from "react-native";
import { useTranslation } from "react-i18next";
import { Button, SIZE } from "@dehaat/dds";

interface Props {
  onClick: () => void;
  btnStyle?: StyleProp<ViewStyle>;
}

const Okay = ({ onClick, btnStyle }: Props) => {
  const { t } = useTranslation();

  return (
    <Button
      text={t("okay")}
      onClick={onClick}
      buttonStyle={btnStyle}
      size={SIZE.large}
    />
  );
};

export default Okay;
